import TextTitleCompressedHeavyUpperCase
from 'components/TextTitleCompressedHeavyUpperCase'
import React from 'react'

export default function TextTitleCompressedHeavy (props) {
  return (
    <TextTitleCompressedHeavyUpperCase
      style={{
        letterSpacing: '0.02em',
        textTransform: 'none'
      }}
      {...props}
    />
  )
}
